import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import { useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { ThreeDots } from 'react-loader-spinner';

import WithError from '../../components/with-error/WithError';
import { Input } from '../../components/common-inputs';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import CommonButton from '../../components/common-button/CommonButton';

import scss from '../Security.module.scss';

const ForgotPasswordForm = ({ handleSubmit }) => {
  const { t } = useTranslation('securityPage');
  const { valid } = useFormState();
  const isTablet = useMediaQuery('(max-width: 1024px)');
  const isLoading = useSelector((state) => state.securityNew.isLoading);

  return (
    <form className={scss.form} onSubmit={handleSubmit}>
      <h1 className={scss.title}>{t('forgotPassword')}</h1>

      <div className={scss.items}>
        <h4 className={scss.subtitle}>{t('forgotPasswordSubtitle')}</h4>

        <Field name='username'>
          {({ meta, input }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
              <Input
                type='text'
                placeholder={isTablet ? t('email') : t('enterYourEmail')}
                tabIndex={1}
                isError={meta.touched && meta.error}
                formProps={input}
                autoComplete='username'
                disabled={isLoading}
                LeftIcon={<Icon icon={ICONS.User} />}
              />
            </WithError>
          )}
        </Field>
      </div>

      <div className={scss.buttons}>
        <CommonButton styleColor='primary' type='submit' maxWidth={190} disabled={!valid || isLoading}>
          {isLoading ? <ThreeDots height={15} width={40} /> : null}
          {t('resetPassword')}
        </CommonButton>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
